import { useSnackbar } from "notistack";
import { useAppDispatch } from "../redux";
import { useCreateUserPreferenceMutation, useLazyGetUserPreferencesQuery } from "../redux/services";
import { setUserPreferences } from "../redux/slices/auth";
import { openBackdrop, closeBackdrop } from "../redux/slices/backdrop";
import { LocalStorageKeys, parseJwt } from "../utils";

interface IPreferenceDetails {
    key: string;
    value: string;
    onRefetch?: () => {};
}

export const useUserPreference = () => {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const [savePreference] = useCreateUserPreferenceMutation();
    const [getUserPreferences] = useLazyGetUserPreferencesQuery({ refetchOnReconnect: true, refetchOnFocus: true });

    const token = localStorage.getItem(LocalStorageKeys.authToken) || "";

    const data = token ? parseJwt(token) : {};

    const onSavePreference = async (preference: IPreferenceDetails) => {
        dispatch(openBackdrop("Saving the preference..."))
        await savePreference({ key: preference.key, value: preference.value }).unwrap().then((res: any) => {
            if (!res?.title) {
                enqueueSnackbar(res?.message ?? 'Preference Saved Successfully!', { variant: "success" });
                preference.onRefetch?.();
                fetchUserPreference();
            }
        }).catch((error: any) => {
            console.error(`Error while saving the preference: ${error}`)
            enqueueSnackbar(error?.data?.title ?? 'Oops! Something went wrong unable to save the preference.', { variant: "error" })
        }).finally(() => {
            dispatch(closeBackdrop());
        });
    };

    const fetchUserPreference = async () => {
        dispatch(openBackdrop("Fetching User Preference Details..."));
        await getUserPreferences({ user_id: data?.sub })
            .unwrap()
            .then((res) => {
                if (res.length > 0) {
                    dispatch(setUserPreferences(res));
                }
            })
            .catch((error) => {
                console.error("User Preference Error: ", JSON.stringify(error))
            })
            .finally(() => {
                dispatch(closeBackdrop());
            });
    }

    return onSavePreference;
};